import React from 'react';
import { Typography, Card, CardContent, Box } from '@mui/joy';
import MainLayout from '../../components/Layout/MainLayout';

const AnalyticsPage = () => {
  return (
    <MainLayout currentPage="analytics">
      <Box>
        <Typography level="h2" sx={{ fontWeight: 600, mb: 3 }}>
          Analytics & Reports
        </Typography>
        
        <Card variant="outlined">
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <Box sx={{ fontSize: '4rem', mb: 2 }}>📊</Box>
            <Typography level="title-lg" sx={{ mb: 1 }}>
              Analytics Dashboard Coming Soon
            </Typography>
            <Typography level="body-md" sx={{ color: 'neutral.600' }}>
              View detailed analytics and performance reports for your digital signage network.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </MainLayout>
  );
};

export default AnalyticsPage;